import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Switch,
  FormControlLabel,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Form, Button } from "react-bootstrap";
import translations from "../utils/translations";
import { useDispatch, useSelector } from "react-redux";
import { getBrokerInformation } from "../store/broker";

const PdfSettingsModal = ({ open, onClose }) => {
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  const pdfSettingsText = translations[languagepreference].pdfSettingsModal;
  // State for the toggles
  const [showTOC, setShowTOC] = useState(false);
  const [showAnsweredOnly, setShowAnsweredOnly] = useState(false);
  const [isFrench, setIsFrench] = useState(false); // Local state to manage language toggle

  // Effect to load settings from local storage
  useEffect(() => {
    const tocSetting = localStorage.getItem("showTOC") === "true";
    const answeredOnlySetting =
      localStorage.getItem("showAnsweredOnly") === "true";
    const pdfLanguagePrefIsFrench =
      localStorage.getItem("pdfLanguagePrefIsFrench") === "true";
    setShowTOC(tocSetting);
    setShowAnsweredOnly(answeredOnlySetting);

    setIsFrench(pdfLanguagePrefIsFrench);
  }, []);

  // Function to handle toggle changes
  const handleToggleChange = (settingName) => (event) => {
    const value = event.target.checked;
    localStorage.setItem(settingName, value);
    if (settingName === "showTOC") {
      setShowTOC(value);
    } else if (settingName === "showAnsweredOnly") {
      setShowAnsweredOnly(value);
    } else if (settingName === "pdfLanguagePrefIsFrench") {
      setIsFrench(value);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2, // Rounded corners
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            marginBottom: 2, // Adds space below the header
            paddingTop: 1, // Adjust for close button
          }}
        >
          {pdfSettingsText.title}
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={showTOC}
              onChange={handleToggleChange("showTOC")}
            />
          }
          label={pdfSettingsText.displayTOC}
        />
        <FormControlLabel
          control={
            <Switch
              checked={showAnsweredOnly}
              onChange={handleToggleChange("showAnsweredOnly")}
            />
          }
          label={pdfSettingsText.displayAllQuestions}
        />
        <FormControlLabel
          control={
            <Switch
              checked={isFrench}
              onChange={handleToggleChange("pdfLanguagePrefIsFrench")}
            />
          }
          label={pdfSettingsText.displayInFrench}
        />
      </Box>
    </Modal>
  );
};

export default PdfSettingsModal;
